import {Component, OnInit} from '@angular/core';
import {UserService} from '../../../user/services/user/user.service';
import {NotificationService} from '../../services/notification/notification.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {SignalRService} from '../../services/signalr/signal-r.service';

@Component({
  selector: 'avatar-component',
  templateUrl: './avatar-component.component.html',
  styleUrls: ['./avatar-component.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: '1',
        // width: '*',
        // height: '*',
      })),
      state('closed', style({
        opacity: '0',
        'pointer-events': 'none'
        // width: '0px',
        // height: '0px',
      })),
      transition('open => closed', [
        animate('0.2s')
      ]),
      transition('closed => open', [
        animate('0.2s')
      ]),
    ]), ],
})
export class AvatarComponentComponent implements OnInit {
  notifNumber: number;
  notificationPopupOpen: boolean = false;

  constructor(public userService: UserService,
              public notificationService: NotificationService,
              public signalRService: SignalRService) {
  }

  async ngOnInit(): Promise<void> {
    await this.notificationService.getAllNotifications();
    this.subscribeToSignalR();
  }

  private subscribeToSignalR(): void {
    this.signalRService.notificationHandler.onReceive.subscribe( x => {
      this.notificationService.notifications.unshift(x);
    });
  }

  openNotificationModal(): void {
    setTimeout(() => {
      this.notificationPopupOpen = true;
    }, 0 );
  }

  closePopup(): void {
    this.notificationPopupOpen = false;
  }

}
